import React from "react"
import styles from "./SettingsButton.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEllipsisHAlt } from "@fortawesome/pro-light-svg-icons/faEllipsisHAlt"
import cn from "classnames"
import { ClassProps } from "../../utility/common/props"
import { testId } from "../../utility/tests/testId/common"
import { SizeProp } from "@fortawesome/fontawesome-svg-core"
import TooltipTrigger from "../TooltipTrigger/TooltipTrigger"
import { Placement } from "react-bootstrap/Overlay"

const tooltipDelay = { show: 450, hide: 0 }

export interface SettingsButtonProps extends ClassProps {
    onClick?: () => void
    iconSize?: SizeProp
    iconCls?: string
    tooltipText?: string
    tooltipPlacement?: Placement
    tooltipClassName?: string
    id?: string
}

const SettingsButton: React.FC<SettingsButtonProps> = props => {
    const {
        className,
        onClick,
        iconSize = "lg",
        iconCls,
        tooltipText,
        tooltipPlacement = "left",
        id = "",
        tooltipClassName
    } = props

    const settingsButton = (
        <div className={cn(styles.btnSettings, className)} onClick={onClick} data-testid={testId.settingsButton}>
            <FontAwesomeIcon icon={faEllipsisHAlt} size={iconSize} className={cn(styles.btnSettings__icon, iconCls)} />
        </div>
    )

    if (tooltipText) {
        return (
            <TooltipTrigger
                id={id}
                placement={tooltipPlacement}
                content={tooltipText}
                delay={tooltipDelay}
                className={tooltipClassName}
            >
                {settingsButton}
            </TooltipTrigger>
        )
    }

    return settingsButton
}

export default SettingsButton
